import { createApiClient, createMissionsApi } from '@teamofone/api-client'
import {
  currentApiHeaders,
  currentDevIdentity,
  currentJwtAsync,
} from './slackClient'
import { dispatchUnauthorized } from './auth/unauthorized'

export type {
  MissionTemplate,
  MissionGoal,
  Mission,
  MetricSample,
  TeamBudget,
  EnableTemplateResult,
} from '@teamofone/api-client'
export { currentDevIdentity }

const baseUrl =
  (import.meta.env.VITE_TEAMOFONE_API_URL as string | undefined) ??
  'http://localhost:6055/devtools/teamofone'

// Match the slackClient/teamsClient wiring: forward source-id +
// dev identity headers (x-user-id / x-location-id) on every request
// so the BE TeamofoneAuthGuard can resolve the caller in dev mode.
const client = createApiClient({
  baseUrl,
  getToken: currentJwtAsync,
  getExtraHeaders: currentApiHeaders,
  onUnauthorized: dispatchUnauthorized,
})

export const missionsApi = createMissionsApi(client)
